import React from 'react';

const CompassFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="compass-fill_svg__a"
                d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0m3.5 6.5L8.75 8.75 6.5 13.5l4.75-2.25L13.5 6.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="compass-fill_svg__b" fill="#fff">
                <use xlinkHref="#compass-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#compass-fill_svg__a" />
            <g mask="url(#compass-fill_svg__b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CompassFillSvg.displayName = 'CompassFillSvg';
export default CompassFillSvg;
